


































import {Component, Prop} from 'vue-property-decorator'
import MyWalletTotalBalanceCard from '@/components/myWallet/MyWalletTotalBalanceCard.vue'
import MyWalletAddressCard from '@/components/myWallet/MyWalletAddressCard.vue'
import MyWalletUnclaimedGasSection from '@/components/myWallet/MyWalletUnclaimedGasSection.vue'
import {MyWalletCacheAssist} from '@/helpers/MyWalletCacheAssist'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import MyWalletChooseWallet from '@/components/myWallet/MyWalletChooseWallet.vue'

@Component({
  components: {
    MyWalletChooseWallet,
    MyWalletUnclaimedGasSection,
    MyWalletTotalBalanceCard,
    MyWalletAddressCard,
  },
})
export default class MyWalletSection extends MixinScreenSize {
  @Prop({type: MyWalletCacheAssist, required: true})
  cacheAssist!: MyWalletCacheAssist
}
